import { render, staticRenderFns } from "./ProductAudit.vue?vue&type=template&id=4de0f88c&scoped=true"
import script from "./ProductAudit.vue?vue&type=script&lang=js"
export * from "./ProductAudit.vue?vue&type=script&lang=js"
import style0 from "./ProductAudit.vue?vue&type=style&index=0&id=4de0f88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0f88c",
  null
  
)

export default component.exports